module.exports = __webpack_public_path__ + "img/extra_xp.0fb48308.png";